import { apiSlice } from "../../../store/slices/api/apiSlice";
import { IBaseMutationResponse } from "../../../utils/customBaseQuery";
import { Xapi } from "./types/xapi";

export const telemetryApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    addTelemetry: build.mutation<IBaseMutationResponse, Xapi>({
      query: (body) => {
        return {
          url: "/kafka/xAPI/send",
          method: "POST",
          body
        };
      },
      extraOptions: {
        service: "Telemetry"
      }
    }),
    getUserIP: build.query<any, any>({
      query: () => {
        return {
          url: "/proxy",
          method: "GET",
          headers: {
            service: "ipinfo",
            apikey: `${import.meta.env.VITE_IP_INFO_API_KEY}`
          }
        };
      },
      keepUnusedDataFor: 60,
      extraOptions: {
        service: "IP_Info"
      }
    })
  })
});

export const {
  useAddTelemetryMutation,
  useGetUserIPQuery,
  useLazyGetUserIPQuery
} = telemetryApi;
